import { render, staticRenderFns } from "./CheckboxSettingsModal.vue?vue&type=template&id=086205db&lang=pug"
import script from "./CheckboxSettingsModal.vue?vue&type=script&lang=js"
export * from "./CheckboxSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./CheckboxSettingsModal.vue?vue&type=style&index=0&id=086205db&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports